import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { useAuth, formatError } from "@/context/AuthContext";

const STORY = "https://static.prod-images.emergentagent.com/jobs/58fc8f05-e99b-4946-b4cb-e7f6df7eb0e5/images/89720b52b4413453c42517f6d6037d61c0bbafa7991fdd9f981b2f68dd361ff2.jpeg";
const LOGO = "https://static.prod-images.emergentagent.com/jobs/58fc8f05-e99b-4946-b4cb-e7f6df7eb0e5/images/94db3a8fd9595299dc077527071a054f31c15ec9f83972e813d55c616ce12086.jpeg";

export default function Register() {
    const { register } = useAuth();
    const navigate = useNavigate();
    const [params] = useSearchParams();
    const [form, setForm] = useState({ name: "", email: "", password: "", referral_code: params.get("ref") || "" });
    const [busy, setBusy] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setBusy(true);
        try {
            await register(form);
            toast.success("Welcome to Sherrie's practice.");
            navigate("/account");
        } catch (err) { toast.error(formatError(err.response?.data?.detail)); setBusy(false); }
    };

    const input = "w-full bg-surface border border-gold/20 rounded-xl px-4 py-3 text-cream placeholder:text-faded focus:outline-none focus:ring-1 focus:ring-gold";

    return (
        <div className="min-h-[calc(100vh-72px)] grid md:grid-cols-2">
            <div className="flex items-center justify-center p-8 order-2 md:order-1">
                <form onSubmit={submit} className="w-full max-w-sm" data-testid="register-form">
                    <span className="overline-label">Join Us</span>
                    <h1 className="mt-3 font-serif text-4xl text-cream mb-8">Create Account</h1>
                    <div className="space-y-4">
                        <input required placeholder="Name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className={input} data-testid="register-name" />
                        <input required type="email" placeholder="Email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className={input} data-testid="register-email" />
                        <input required type="password" placeholder="Password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} className={input} data-testid="register-password" />
                        <input placeholder="Referral code (optional)" value={form.referral_code} onChange={(e) => setForm({ ...form, referral_code: e.target.value })} className={input} data-testid="register-referral" />
                    </div>
                    <button disabled={busy} data-testid="register-submit" className="mt-6 w-full bg-gold text-ink rounded-full py-3 font-medium hover:bg-goldbright transition-colors active:scale-95 disabled:opacity-60">
                        {busy ? "Creating…" : "Create Account"}
                    </button>
                    <p className="mt-6 text-sm text-ash text-center">Already have an account? <Link to="/login" className="text-gold hover:text-goldbright">Sign in</Link></p>
                </form>
            </div>
            <div className="relative hidden md:block order-1 md:order-2">
                <img src={STORY} alt="" className="absolute inset-0 w-full h-full object-cover" />
                <div className="absolute inset-0 bg-ink/75" />
                <div className="relative z-10 h-full flex flex-col items-center justify-center p-12 text-center">
                    <img src={LOGO} alt="Sacred Earthworks" className="w-60 rounded-2xl border border-gold/20" />
                    <p className="mt-8 font-serif text-3xl text-cream leading-tight">Your fence is our fence.<br />Step under the cover.</p>
                </div>
            </div>
        </div>
    );
}
